/* eslint-disable keyword-spacing */
import { fetchData, ENDPOINT_HOST } from './api_helper';

const apiURL = `${ENDPOINT_HOST}partners/`;

const fetchPartners = (page, searchTerm = '', orderInfo) => new Promise(((resolve, reject) => {
  let endpointURL = `${apiURL}?page=${page}&term=${searchTerm}`;
  if(orderInfo) {
    endpointURL = `${apiURL}?page=${page}&term=${searchTerm}&order=${orderInfo.order}&direction=${orderInfo.direction}`;
  }
  fetchData(endpointURL, 'get', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const fetchAllPartner = () => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}?need_all=true`;
  fetchData(endpointURL, 'get', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const fetchPartner = id => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}${id}`;
  fetchData(endpointURL, 'get', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const fetchPartnerChartData = (id,siteId) => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}${id}/partner_chart?site_id=${siteId}`;
  fetchData(endpointURL, 'get', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const fetchPartnerNotifications = id => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}${id}/partner_notifications`;
  fetchData(endpointURL, 'get', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const updatePartner = params => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}${params.id}`;
  fetchData(endpointURL, 'put', params, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const createPartner = params => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}`;
  fetchData(endpointURL, 'post', params, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const deletePartner = id => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}${id}`;
  fetchData(endpointURL, 'delete', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const fetchCommonData = id => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}${id}/common_data_sync?for_web=true`;
  fetchData(endpointURL, 'get', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

export default {
  fetchPartners,
  fetchAllPartner,
  fetchPartner,
  fetchPartnerChartData,
  fetchPartnerNotifications,
  updatePartner,
  createPartner,
  deletePartner,
  fetchCommonData,
};



// WEBPACK FOOTER //
// ./src/api/partners.js